import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getmasteractivitiydetailsThunk = createAsyncThunk(
  "pgeactivity/getmasteractivitiydetails",
  async (params) => {
    const { preferedlanguage, program, subject, clas, skillsetid } = params;
    let response = await api.get(
      "getmasterpgeactivitiydetailsnostage/" +
        preferedlanguage +
        "/" +
        program +
        "/" +
        subject +
        "/" +
        clas +
        "/" +
        skillsetid
    );
    return response.data;
  }
);

export const getpgeactivityskillThunk = createAsyncThunk(
  "pgeactivity/getpgeactivityskill",
  async (params) => {
    const { preferedlanguage, program, subject, clas } = params;
    let response = await api.get(
      "getpgeactivityskill/" +
        preferedlanguage +
        "/" +
        program +
        "/" +
        subject +
        "/" +
        clas
    );
    // console.log(api, "aaaapa");
    console.log(response, "response");
    return response.data;
  }
);

export const createmasteractivitiesThunk = createAsyncThunk(
  "pgeactivity/create",
  async (body) => {
    let response = await api.post("/createmasterpgeactivities", body);
    return response.data;
  }
);

export const updatemasteractivitiesThunk = createAsyncThunk(
  "pgeactivity/update",
  async (reqbody) => {
    const id = reqbody._id;
    const body = reqbody.body;
    let response = await api.put("updatemasterpgeactivities/" + id, body);
    return response.data;
  }
);
